import type { FC } from 'react';

import RemovableFilterValue from '../../../../panels/search_filters/removable_filter_value/removable_filter_value';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['infoText', 'iconName'] as const;

const Field = formField(RemovableFilterValue, {
  transformProps: (props) => pickProps(props, componentProps),
});

type RemovableFilterValueWrapperProps = FieldWrapperProps<typeof Field>;

const RemovableFilterValueWrapper: FC<RemovableFilterValueWrapperProps> = (
  props,
) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default RemovableFilterValueWrapper;
